import request from './common/request'
import { exportExcelByGet } from './common/exportExcel'
import qs from 'qs'
// import moment from 'moment'

import { SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL } from './urls'

/**
 * 获取报名列表
 * @param {*} params
 * @returns
 */
async function list (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/entryvalue`,
    method: 'GET',
    params: params
  })
}

/**
 * 获取代报名的成员列表
 * @param {*} params
 * @returns
 */
async function members (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/entryvalue/${params.id}/members`,
    method: 'GET'
  })
}

/**
 * 淘汰
 * @param {*} data
 * @returns
 */
async function siftOut (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/siftout`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

/**
 * 晋级
 * @param {*} data
 * @returns
 */
async function promotion (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/promotion`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

/**
 * 完成打分阶段
 * @param {*} data
 * @returns
 */
async function rateFinish (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/ratefinish`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

/**
 * 打分
 * @param {*} data
 * @returns
 */
async function rate (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.entryValueId}/rate`,
    method: 'POST',
    data: qs.stringify(data)
  })
}

async function rateList (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/rate`,
    method: 'GET'
  })
}

async function exportExcel (params) {
  // const filename = `${moment().format('YYYY-MM-DD')}-报名表-${params.matchId}.xlsx`
  return exportExcelByGet(params, `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/entryvalue/export`, params.filename)
}

async function changeAvailableStatus (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/availableStatus/${data.status}`,
    method: 'PUT'
  })
}

async function changeAuditStatus (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/${data.id}/auditStatus/${data.status}`,
    method: 'PUT'
  })
}

async function getSessionMembers (params) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${params.competitionId}/entryvalue/members`,
    method: 'GET',
    params
  })
}

async function resetSession (data) {
  return request({
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${data.competitionId}/entryvalue/resetSession`,
    method: 'PUT',
    data: qs.stringify(data)
  })
}

/**
 * 导入报名数据
 * @param {FormData} formData
 * @param {Number} competitionId - 活动ID
 * @param {Number|String} merchantId - 商户ID（可选）
 * @returns
 */
async function importExcel (formData, competitionId, merchantId) {
  const config = {
    url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/${competitionId}/entryvalue/import`,
    method: 'POST',
    data: formData
  }
  
  // 如果传入了 merchantId，作为查询参数传递
  if (merchantId) {
    config.params = {
      merchantId
    }
  }
  
  return request(config)
}

export default {
  list,
  members,
  siftOut,
  promotion,
  rateFinish,
  rate,
  rateList,
  exportExcel,
  changeAvailableStatus,
  changeAuditStatus,
  getSessionMembers,
  resetSession,
  importExcel
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-competition-entry-value.js